import React from "react";
import { render } from "react-dom";

const elementStore = {};

const getElements = () => Object.keys(elementStore)
  .map(key => elementStore[key])
  .filter(Boolean);

class ExternalComponentRenderer extends React.Component {
  constructor(props) {
    super(props);

    const self = this;
    const { container, silentFail } = self.props;

    self.elementContainer = document.querySelector(container);
    if (!self.elementContainer) {
      if (silentFail) {
        self.elementContainer = {};
      } else {
        throw new ReferenceError(`Unable to find element with selector "${container}"`);
      }
    }
  }

  setElementId(id) {
    this.elementId = id;
  }

  updateElement(content) {
    const self = this;

    elementStore[self.elementId] = content;

    self.updateElements();
  }

  updateElements() {
    render(
      <React.Fragment>
        {getElements()}
      </React.Fragment>,
      this.elementContainer
    );
  }

  removeElement() {
    const self = this;

    delete elementStore[self.elementId];

    self.updateElements();
  }
}

export default ExternalComponentRenderer;



// WEBPACK FOOTER //
// ./providers/ExternalComponentRenderer.jsx